module.exports = __webpack_public_path__ + "img/s12_1-copia.79dbde9e.webp";